import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Download } from "react-bootstrap-icons";
import Logo from "../../assets/Logo.png";
import Resume from "../../assets/Sandun resume SE.pdf"
import "./NavBar.css";

function NavBar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const handleScroll = (event, targetId) => {
    event.preventDefault();
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar expand="lg" className="bg-white nav-section">
      <Container>
        <Navbar.Brand href="#home">
          <img src={Logo} alt="logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="w-100 justify-content-center align-items-center navbar-section">
            <Nav.Link href="#skills" onClick={(e) => handleScroll(e, "skills")}>
              Skills
            </Nav.Link>
            <Nav.Link
              href="#experience"
              onClick={(e) => handleScroll(e, "experience")}
            >
              Experience
            </Nav.Link>
            <Nav.Link href="#about" onClick={(e) => handleScroll(e, "about")}>
              About
            </Nav.Link>
            <Nav.Link
              href="#project"
              onClick={(e) => handleScroll(e, "projects")}
            >
              Projects
            </Nav.Link>
            <Nav.Link
              href="#contact"
              onClick={(e) => handleScroll(e, "contact")}
            >
              Contact
            </Nav.Link>
          </Nav>
          <Nav className="justify-content-end download-btn">
            <a href={Resume}
              download="Sandun resume SE.pdf"
              style={{textDecoration: "none"}}
              >
              <Button>
                Resume
                <Download />
              </Button>
            </a>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
